import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import {
  AdminMenuLayout,
  ModalFulfillmentCompany,
} from "../../../shared/components";
import { WrapperCardFulfillmentCompany } from "./styled";
import { useFulfillmentCompany } from "../hooks";
import { selectModalFulfillmentCompany } from "../../../redux";
import { TableFulfillmentCompany } from "./TableFulfillmentCompany";

export const FulfillmentCompany = () => {
  const modalFulfillmentCompany = useSelector(selectModalFulfillmentCompany);
  const {
    isUpdateFulfillmentCompany,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalFulfillmentCompanyState,
  } = useFulfillmentCompany();

  return (
    <AdminMenuLayout
      pageDescription="FulfillmentCompany"
      title="FulfillmentCompany"
    >
      <WrapperCardFulfillmentCompany>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalFulfillmentCompanyState}
            >
              Agregar nueva transportadora
            </Button>
          </Col>
        </Row>
        <TableFulfillmentCompany />
        {modalFulfillmentCompany && isUpdateFulfillmentCompany && (
          <FormProvider {...formMethodsUpdate}>
            <ModalFulfillmentCompany />
          </FormProvider>
        )}
        {modalFulfillmentCompany && !isUpdateFulfillmentCompany && (
          <FormProvider {...formMethodsCreate}>
            <ModalFulfillmentCompany />
          </FormProvider>
        )}
      </WrapperCardFulfillmentCompany>
    </AdminMenuLayout>
  );
};
